import { Injectable } from '@nestjs/common';
import { BloodDonationCertificateResponse, CommonResponse, ErrorResponse, GlobalResponseObject, MessageBroadcastStatusEnum, MessageParameters, MessageTypeEnum, PriorityEnum, WhatsappLogDto, whatsappsLogDto } from '@schemax-whatsapp/shared-models';
import { BiMessageRepository } from '../entity/repository/bi-message.repository';
import { MessageRequest } from './dto/message.request';
import { appConfig } from '../../../config';
import { BiMessage } from '../entity/bi-message.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository, getManager } from 'typeorm';
import { BroadcastMessageRequest } from './dto/broadcast-message.request';
import { BroadcastMessage } from './entity/broadcast-message.entity';
import { BroadcastContact } from './entity/broadcast-contact.entity';
import { BMIdRequest } from './dto/bm-id.request';
import { BloodDonationUserRequest } from './dto/blood-donation-user.request';
import { BloodDonationUser } from './entity/blood-donation-users.entity';
import { ApiExtraModels } from '@nestjs/swagger';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { BiMessageService, WhatsAppMetaService } from '@schemax-whatsapp/shared-services/whatsapp-api';
const nodeHtmlToImage = require('node-html-to-image');
const fs = require('fs');
const path = require('path');

const ultramsg = require('ultramsg-whatsapp-api');
const instance_id = "instance18516" // Ultramsg.com instance id
const ultramsg_token = appConfig.keys.whatsappLicence;  // Ultramsg.com token
const api = new ultramsg(instance_id, ultramsg_token);

@Injectable()
export class MessageBroadcastService {
    private templateNames = {
        schemaxBi: { name: 'schemax_bi', language: 'en_us' },
        schemaxBroadcast: { name: 'schemax_broadcast', language: 'en' }
    };

    constructor(
        @InjectRepository(BiMessage) private biMsgRepo: Repository<BiMessage>,
        @InjectRepository(BroadcastMessage) private bmRepo: Repository<BroadcastMessage>,
        @InjectRepository(BroadcastContact) private bcRepo: Repository<BroadcastContact>,
        @InjectRepository(BloodDonationUser) private bloodDonUser: Repository<BloodDonationUser>,
        private wpService: WhatsAppMetaService,
        private whatsAppService: BiMessageService

    ) {

    }

    /**
     * 
     * @param body 
     * @returns 
     */
    async sendMessage(msgReq: MessageRequest): Promise<GlobalResponseObject> {
        const messageCode = msgReq.messageCode;
        const userMessage = msgReq.message;
        // check if the message exist
        const msgRec = await this.biMsgRepo.findOne({ where: { biMessageId: messageCode, isActive: true }, relations: ['module'] });
        if (!msgRec) {
            throw new ErrorResponse(0, 'Message record does not exist');
        }
        const roleContacts = []; // await this.roleContactRepo.find({select:['contact'], where: {role: { roleId: msgRec.role.roleId }, company: { companyId: msgRec.company.companyId} }});
        if (roleContacts.length == 0) {
            // throw new ErrorResponse(0, 'Contacts are not mapped to the company : ' + msgRec.company.companyName + ' & role : ' + msgRec.role.roleName);
        }
        // const receivers = ['8790477753'];
        // ['917207605260@c.us'];
        // roleContacts.forEach(rec => receivers.push(rec.contact));
        const message = await this.constructWhatsAppMessage(msgRec, userMessage);
        for (const receiver of msgReq.receivers) {
            // await this.broadcastMessage(receiver, '', message, 'Schemaxtech', false);
            await this.broadcastMessageUsingFb(message, receiver, this.templateNames.schemaxBi.name, this.templateNames.schemaxBi.language);
        }
        return new GlobalResponseObject(true, 0, 'Message sent successfully');
    }

    /**
     * constructs the message
     * @param msgRec 
     * @param userMessage 
     * @returns 
     */
    constructWhatsAppMessage(msgRec: BiMessage, userMessage: string): string[] {
        let alertIcon: any = '';
        let businessImpactIcon = `💣`;
        let priorityCount = Number(msgRec.priority);
        msgRec.messageType == MessageTypeEnum.WARNING ? alertIcon = `⚠️` : null;
        msgRec.messageType == MessageTypeEnum.ALERT ? alertIcon = `💣` : null;
        msgRec.messageType == MessageTypeEnum.NORMAL ? alertIcon = `📢` : null;
        msgRec.priority == PriorityEnum.FIVE_STAR || msgRec.priority == PriorityEnum.FOUR_STAR ? businessImpactIcon = `💥` : '';
        // append the alert icon * no of priority
        let alertIconCopy = '';
        while (priorityCount > 0) {
            alertIconCopy += alertIcon;
            priorityCount--;
        }
        return [`${alertIconCopy}- ${msgRec.module.moduleName} : ${msgRec.activity}\\n\\n${userMessage}`, `${businessImpactIcon}: ${msgRec.impact}`]
        // do not remove this line
        // return `\n*🇸​​​​​🇨​​​​​🇭​​​​​🇪​​​​​🇲​​​​​🇦​​​​​🇽🅒🅡🅤🅧* -${alertIconCopy}- ${msgRec.module.moduleName} : ${msgRec.activity}\\n\\n${userMessage}\n\n*Business Impact* ${businessImpactIcon}: ${msgRec.impact}`;
    }

    /**
     * 
     * @param msgReq 
     */
    async saveBroadCastedMessageToMultipleCustomers(msgReq: BroadcastMessageRequest): Promise<CommonResponse> {
        // return new GlobalResponseObject(true, 0, 'Message saved successfully');
        // save the records into the broadcast entity and broadcast contact

        // iterate each param and convert the new line chars to \\n
        console.log('----------request ---------', msgReq)
        Object.keys(msgReq.messageParams).forEach(key => {
            if (typeof (msgReq.messageParams[key]) == 'string')
                msgReq.messageParams[key] = msgReq.messageParams[key].replace(/(\r\n|\r|\n)/g, '\\n');
        });
        const broadCastEntity = new BroadcastMessage();
        broadCastEntity.companyId = msgReq.companyId;
        broadCastEntity.message = '';
        broadCastEntity.messageType = MessageTypeEnum.NORMAL;
        broadCastEntity.priority = PriorityEnum.ONE_STAR;
        broadCastEntity.createdUser = msgReq.username;
        broadCastEntity.broadcastName = '';
        broadCastEntity.totalMsgCount = msgReq.contacts.length;
        broadCastEntity.templateName = msgReq.templateName;
        broadCastEntity.templateLanguage = msgReq.templateLanguage;
        broadCastEntity.messageParams = msgReq.messageParams;
        const savedEntity = await this.bmRepo.save(broadCastEntity);
        // const updatePath = await this.updatePath(filePath, filename, id)
        const bcEntities = [];
        for (const contact of msgReq.contacts) {
            const bcEntity = new BroadcastContact();
            bcEntity.bmId = savedEntity.id;
            bcEntity.contact = contact;
            bcEntity.createdUser = msgReq.username;
            bcEntity.contactType = 'N';
            bcEntities.push(bcEntity);
        }
        const contactsArray = bcEntities.map((contactObj) => contactObj.contact);
        const messageParamsValue = msgReq.messageParams['1'];
        // const result = await this.updatePath
        let messageStatus;
        let parameters ;
        if(msgReq.templateName == 'schemax_broadcast'){
             parameters = [
                {"type": "text","text" :messageParamsValue}
           ]
        }else{
        const headerParameters = [
            {
                "type": "image", "image": {
                    "link": "http://206.189.138.212/whatsappimages/varunbajaj/2wheeler/bajaj/avenger/avenger_160_Street.jpg"
                }
            }
        ]
        const bodyParameters = [
            { "type": "text", "text": messageParamsValue }
        ]
         parameters = [
            {
                "type": "header",
                "parameters": headerParameters
            },
            {
                "type": "body",
                "parameters": bodyParameters
            }
        ]
        }
        console.log('parameters', parameters)
        for (const contact of contactsArray) {
            const req = new MessageParameters("91" + contact, msgReq.templateName, parameters,'template', 'en_us')
            if(msgReq.templateName === 'schemax_broadcast'){
                messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            }else{
                messageStatus = await this.wpService.sendMessageWithHeaderThroughFbApi(req);
            }
            if (messageStatus.status) {
                const whtapplogDto = new whatsappsLogDto(contact, 'schemax_broadcast', 'Schemaxtech', 3, 15)
                const res = await this.whatsAppService.createWhatappLog(whtapplogDto)
            } else {
                return new CommonResponse(false, 1000, 'Message not sent')
            }
        }

        await this.bcRepo.save(bcEntities, { reload: false });
        const bmIdReq = new BMIdRequest(savedEntity.id, 'system');
        this.triggerMessageBroadCasting(bmIdReq);
        return new CommonResponse(true, 0, 'Message saved successfully', savedEntity);
    }

    async createTemplate(msgReq: BroadcastMessageRequest): Promise<CommonResponse> {
        const bcEntities = [];
        console.log('**********************', msgReq)
        for (const contact of msgReq.contacts) {
            const bcEntity = new BroadcastContact();
            bcEntity.bmId = msgReq.id;
            bcEntity.contact = contact;
            bcEntity.createdUser = msgReq.username;
            bcEntity.contactType = 'N';
            bcEntities.push(bcEntity);
        }
        const contactsArray = bcEntities.map((contactObj) => contactObj.contact);
        const messageParamsValue = msgReq.messageParams['1'];
        let filePath = msgReq.filePath
        let modifiedFilePath = filePath.replace(/\\/g, "/");
        // let modifiedFilePath = 'message-uploads/bi-photos/20220902_090309-b660.jpg';
        console.log('modifiedFilePath', modifiedFilePath)
        let messageStatus;
        let parameters;
        if (msgReq.templateName == 'schemax_broadcast') {
            parameters = [
                { "type": "text", "text": messageParamsValue }
            ]
        } else {
            const headerParameters = [
                {
                    "type": "image", "image": {
                        "link": `http://206.189.138.212/whatsapp-bi/dist/apps/services/whatsapp-api/${modifiedFilePath}`
                    }
                }
            ]
            console.log(headerParameters)

            const bodyParameters = [
                { "type": "text", "text": messageParamsValue }
            ]

            parameters = [
                {
                    "type": "header",
                    "parameters": headerParameters
                },
                {
                    "type": "body",
                    "parameters": bodyParameters
                }
            ]
        }
        console.log('parameters', parameters)
        for (const contact of contactsArray) {
            const req = new MessageParameters("91" + contact, msgReq.templateName, parameters, 'template', 'en_us')
            if (msgReq.templateName === 'schemax_broadcast') {
                messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            } else {
                messageStatus = await this.wpService.sendMessageWithHeaderThroughFbApi(req);
            }
            console.log(messageStatus)
            if (messageStatus.status) {
                const whtapplogDto = new whatsappsLogDto(contact, 'schemax_broadcast', 'Schemaxtech', 3, 15)
                const res = await this.whatsAppService.createWhatappLog(whtapplogDto)
            } else {
                return new CommonResponse(false, 1000, 'Message not sent')
            }
        }

        await this.bcRepo.save(bcEntities, { reload: false });
        // const bmIdReq = new BMIdRequest(savedEntity.id, 'system');
        // this.triggerMessageBroadCasting(bmIdReq);
        return
    }

    async updatePath(filePath: string, filename: string, id: number): Promise<CommonResponse> {
        try {
            const filePathUpdate = await this.bmRepo.update(
                { id: id },
                { filePath: filePath, fileName: filename },
            );
            const result = await this.bmRepo.findOne({ where: { id: id } })
            console.log('************result************', result)
            if (filePathUpdate.affected > 0) {
                //whatsapp template creation

                return new CommonResponse(true, 11, 'uploaded successfully', filePath);
            }
            else {
                return new CommonResponse(false, 11, 'uploaded failed', filePath);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * 
     * @param bmIdReq 
     */
    async triggerMessageBroadCasting(bmIdReq: BMIdRequest): Promise<GlobalResponseObject> {
        // get the template name
        const bmRec = await this.bmRepo.findOne({ select: ['templateName', 'templateLanguage', 'messageParams'], where: { id: bmIdReq.bmId } });
        const templateName = bmRec.templateName;
        const language = bmRec.templateLanguage;
        const paramsJson = bmRec.messageParams;

        // construct the params form the json
        const messageParams = Object.values(paramsJson);

        const pendingContacts = await this.bcRepo.find({ select: ['contact', 'id'], where: { bmId: bmIdReq.bmId, status: MessageBroadcastStatusEnum.PENDING } });
        if (pendingContacts.length == 0) {
            throw new ErrorResponse(0, 'No pending messages found. All are sent')
        }
        // const messageRec = await this.bmRepo.findOne({ select: ['message', 'image', 'messageType', 'priority', 'broadcastName'], where: {id: bmIdReq.bmId } });
        // const alertString =  this.getAlertString(messageRec.priority, messageRec.messageType);

        for (const receiver of pendingContacts) {
            const suffix = ''; // receiver.contactType == 'G' ? '@g.us' : '@c.us';

            // convert the message by replacing new line with \n
            // const text =  alertString + messageRec.broadcastName +'\\n'+messageRec.message.replace(/(\r\n|\r|\n)/g, '\\n');wpService
            const res = await this.broadcastMessageUsingFb(messageParams, "91" + receiver.contact + suffix, templateName, language);
            if (res) {
                // await this.broadcastMessage("91"+receiver.contact+suffix, '', alertString+'\n\n'+messageRec.message, 'Schemaxtech', false);
                await this.bcRepo.update({ id: receiver.id }, { status: MessageBroadcastStatusEnum.SENT, messageId: res });
            } else {
                await this.bcRepo.update({ id: receiver.id }, { status: MessageBroadcastStatusEnum.PENDING, messageId: res });
            }
        }
        return new GlobalResponseObject(true, 0, 'Message broadcasted successfully');
    }

    /**
     * constructs the message
     * @param msgRec 
     * @param userMessage 
     * @returns 
     */
    getAlertString(priority: PriorityEnum, type: MessageTypeEnum): string {
        let alertIcon: any = '';
        let businessImpactIcon = `💣`;
        let priorityCount = Number(priority);
        type == MessageTypeEnum.WARNING ? alertIcon = `⚠️` : null;
        type == MessageTypeEnum.ALERT ? alertIcon = `💣` : null;
        type == MessageTypeEnum.NORMAL ? alertIcon = `📢` : null;
        priority == PriorityEnum.FIVE_STAR || priority == PriorityEnum.FOUR_STAR ? businessImpactIcon = `💥` : '';
        // append the alert icon * no of priority
        let alertIconCopy = '';
        while (priorityCount > 0) {
            alertIconCopy += alertIcon;
            priorityCount--;
        }
        return alertIconCopy;
    }

    /**
     * 
     * @param paramsArray 
     * @param templateName 
     * @param recipient 
     * @returns 
     */
    getRequestBodyParamsForPostingMessage(paramsArray: string[], templateName: string, language: string, recipient: string): Object {
        const params = paramsArray.map(rec => {
            return {
                type: "text",
                text: rec
            }
        })
        const bodyParameters = {
            "messaging_product": "whatsapp",
            "to": recipient,
            "type": "template",
            "template": {
                "name": templateName,
                "language": {
                    "code": language
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": params
                    }
                ]
            }
        };
        return bodyParameters;
    }

    /**
     * 
     * @param messageParams 
     * @param recipient 
     * @param templateName 
     * @param language 
     * @returns 
     */
    async broadcastMessageUsingFb(messageParams: string[], recipient: string, templateName: string, language: string): Promise<string> {
        const config = {
            headers: { Authorization: 'Bearer EAAMPZAswUgD4BAOUwlRXgVhMgpFW4eXT3z2ZBcVlIPnTtixguAqc74xFS1ydBrTuCD55njvOS7B9ZB4ZAZB3pvFQ4ySYEMZChD1OkKv5RUQ6wZBwOZCfiOB1F3KZCbqL8CHcDReQSOcjGHAZAzX7oy7ylsmaNpTgacI1aUQ8LydnFXR4PMHMZBDH8ZAz' }
        };
        const bodyParameters = this.getRequestBodyParamsForPostingMessage(messageParams, templateName, language, recipient);

        // console.log(bodyParameters['template']['components'][0]['parameters']);

        return await axios.post('https://graph.facebook.com/v15.0/102194172756615/messages', bodyParameters, config).then(res => {
            return res.data?.messages?.[0].id;
        }).catch(err => {
            console.log(err);
            return null;
        });

    }

    // UN USED CONTENT FROM HERE ON
    async renderBloodDonationCertificate(username: string, phone: string, date: string): Promise<any> {
        // const pathFileName = process.cwd()+`/apps/services/whatsapp-api/src/app/message-broadcast/images/users/${phone}.jpg`;
        // const logoUrl = process.cwd()+'/apps/services/whatsapp-api/src/app/message-broadcast/images/cert.jpeg';
        // /var/www/html/whatsapp-bi/dist/apps/services/whatsapp-api\blood.jpeg'
        const pathFileName = process.cwd() + `/assets/${phone}.jpg`;
        const logoUrl = process.cwd() + '/assets/cert.jpeg';
        username = username.toLocaleUpperCase();
        const prom = new Promise((resolve, reject) => {
            // path.resolve(__dirname, logoUrl)
            fs.readFile(logoUrl, async function (err, data) {
                if (err) {
                    reject(err);
                }
                //  <div style="height: 450px; width: 700px">
                const base64Image = data.toString('base64');
                const dataURI = 'data:image/jpeg;base64,' + base64Image;
                return nodeHtmlToImage({
                    quality: 50,
                    output: pathFileName,
                    type: 'jpeg',
                    puppeteerArgs: {
                        headless: true,
                        args: ['--no-sandbox', '--disable-setuid-sandbox']
                    },
                    html: `
                    <body>
                        <div>
                            <img src={{ imageSource }} class="image"> </img>
                            <div class="content">
                                <div class="line1">
                                    <b>${username}</b>
                                </div>
                                <div class="line3">
                                    ${date}
                                </div>
                            </div>
                        </div>
                    </body>

                    <style>

                        body {
                            width: 1800px;
                            height: 1100px;
                        }

                        .image {
                            object-fit: fill;
                            height: 100%;
                            width: 100%;
                            position: fixed;
                        }

                        .content {
                            background-position: center;
                            background-repeat: no-repeat;
                            background-size: cover;
                            position: fixed;
                            height: 100%;
                            width: 100%;

                            // border: 5px solid black;

                            font-size: 40px;
                            font-family: Calibri;
                        }

                        .line1 {
                            line-height: 2;
                            margin-top: 23.5%;
                            margin-left: 40%;
                            font-weight: bolder;
                        }

                        .line3 {
                            font-weight: bolder;
                            margin-top: 22%;
                            margin-left: 18%;
                        }

                    </style>
                    `,
                    content: { imageSource: dataURI }
                }).then(async res => {
                    // send the whatsapp message

                    return await fs.readFile(pathFileName, async function (err, data) {
                        if (err) {
                            throw err;
                        }
                        const image = data.toString('base64');
                        var priority = 10;
                        var referenceId = "SDK";
                        var nocache = false;
                        // send the image as whats app message
                        // const response = await api.sendImageMessage(`91${req.phone}@c.us`, '', image, priority, referenceId, nocache);

                        // await bloodDonUserLocalRef.update({ id: userId}, { status: MessageBroadcastStatusEnum.SENT});
                        resolve(image);
                    });
                }).catch(err => {
                    console.log(err);
                    reject(err);
                    throw err;
                });
            });
        });
        return await prom.then((imageContent: string) => {
            return `\
                <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js"></script>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js"></script>
                <style>
                    .download-button {
                        color: white;
                        background: #dc3545;
                        border-radius: 0.375rem;
                        padding-x: 0.75rem;
                        padding-y: 0.35rem;
                        height: 30px;
                        width: 100px;
                    }
                    @media (max-width: 1199px) {
                        #image-content {
                            width: 60vw;
                            height: 35vw;
                        }
                    }
                    @media (min-width: 1024px) {
                        #image-content {
                            width: 60vw;
                            height: 35vw;
                        }
                    }

                    @media (min-width: 1024px) and (max-width:1200px) {
                        #image-content {
                            width: 90vw;
                            height: 60vw;
                        }
                    }

                    @media (max-width: 1023px) {
                        #image-content {
                            width: 90vw;
                            height: 65vw;
                        }
                    }

                    @media (max-width: 768px) {
                        #image-content {
                            width: 90vw;
                            height: 65vw;
                        }
                    }

                    @media (max-width: 376px) {
                        #image-content {
                            width: 90vw;
                            height: 65vw;
                        }
                    }

                    @media (max-width: 450px) {
                        #image-content {
                            width: 90vw;
                            height: 60vw;
                        }
                    }
                </style>
                <br/>
                <br/>
                <button class='download-button' id='download-certificate'>Download </button> <br/><br/>
                <hr/>
                <img id='image-content'></img>  \
                <input type=hidden value='${imageContent}' id='image-base-64'/>
                <script>
                $(document).ready(()=> {
                    const imageBase64 = $('#image-base-64').val();
                    $('#image-content').attr('src', 'data:image/png;base64, '+imageBase64);

                    $('#download-certificate').click(()=>{
                        console.log('hello');
                        const Component2 = $("#certificate-image");

                        var image = new Image();
                        image.src = 'data:image/png;base64, '+imageBase64;
                
                        var doc = new jsPDF({ orientation: 'p', unit: 'px', format: [1200, 1000]});
                        doc.addImage(image, 'JPEG', 0, 0, 750, 450);
                        doc.save('certificate.pdf');
                        return;
                    });
                });
                   
                </script>
            `;
            // return new BloodDonationCertificateResponse(true, 0 , 'Message sent successfully', imageContent);
        })
    }

    async sendBloodDonationMessage(req: BloodDonationUserRequest): Promise<GlobalResponseObject> {
        // const pathFileName = `apps/services/whatsapp-api/src/app/message-broadcast/images/users/${req.uniqueId}.jpg`;
        // const logoUrl = 'apps/services/whatsapp-api/src/app/message-broadcast/images/blood.jpeg';
        // const pathFileName = process.cwd()+`/apps/services/whatsapp-api/src/app/message-broadcast/images/users/${req.uniqueId}.jpg`;
        // const logoUrl = process.cwd()+'/apps/services/whatsapp-api/src/app/message-broadcast/images/cert.jpeg';
        // /var/www/html/whatsapp-bi/dist/apps/services/whatsapp-api\blood.jpeg'
        const pathFileName = process.cwd() + `/assets/${req.uniqueId}.jpg`;
        const logoUrl = process.cwd() + '/assets/cert.jpeg';

        const bloodDonUserLocalRef = this.bloodDonUser;
        const userId = await this.saveBloodDonationBroadCastEntry(req.uniqueId, req.username, req.phone, req.constituency);
        // const constituency = req.constituency ? 'Constituency &nbsp&nbsp&nbsp&nbsp&nbsp' + req.constituency : '&nbsp';
        const constituency = req.constituency ? req.constituency.toLocaleUpperCase() + '&nbsp&nbsp&nbspCONSTITUENCY' : '&nbsp';
        const prom = new Promise((resolve, reject) => {
            // path.resolve(__dirname, logoUrl)
            fs.readFile(logoUrl, async function (err, data) {
                if (err) {
                    reject(err);
                }
                //  <div style="height: 450px; width: 700px">
                const base64Image = data.toString('base64');
                const dataURI = 'data:image/jpeg;base64,' + base64Image;
                return nodeHtmlToImage({
                    quality: 50,
                    output: pathFileName,
                    type: 'jpeg',
                    puppeteerArgs: {
                        headless: true,
                        args: ['--no-sandbox', '--disable-setuid-sandbox']
                    },
                    html: `
                    <body>
                        <div>
                            <img src={{ imageSource }} class="image"> </img>
                            <div class="content">
                                <div class="line1">
                                    <b>${req.username}</b>
                                </div>
                                <div class="line2">
                                    <b>${constituency}</b>
                                </div>
                                <div class="line3">
                                    ${req.date}
                                </div>
                            </div>
                        </div>
                    </body>

                    <style>

                        body {
                            width: 1800px;
                            height: 1100px;
                        }

                        .image {
                            object-fit: fill;
                            height: 100%;
                            width: 100%;
                            position: fixed;
                        }

                        .content {
                            background-position: center;
                            background-repeat: no-repeat;
                            background-size: cover;
                            position: fixed;
                            height: 100%;
                            width: 100%;

                            // border: 5px solid black;

                            font-size: 40px;
                            font-family: Calibri;
                        }

                        .line1 {
                            line-height: 2;
                            margin-top: 23.5%;
                            margin-left: 40%;
                            font-weight: bolder;
                        }
                        .line2 {
                            line-height: 1.8;
                            margin-left: 40%;
                            font-weight: bolder;
                        }
                        .line3 {
                            font-weight: bolder;
                            margin-top: 18%;
                            margin-left: 18%;
                        }

                    </style>
                    `,
                    content: { imageSource: dataURI }
                }).then(async res => {
                    // send the whatsapp message

                    return await fs.readFile(pathFileName, async function (err, data) {
                        if (err) {
                            throw err;
                        }
                        const image = data.toString('base64');
                        var priority = 10;
                        var referenceId = "SDK";
                        var nocache = false;
                        // send the image as whats app message
                        // const response = await api.sendImageMessage(`91${req.phone}@c.us`, 'Hello Welcome', image, priority, referenceId, nocache);

                        // await bloodDonUserLocalRef.update({ id: userId}, { status: MessageBroadcastStatusEnum.SENT});
                        resolve(image);
                    });
                }).catch(err => {
                    console.log(err);
                    reject(err);
                    throw err;
                });
            });
        });

        return await prom.then((imageContent: string) => {
            return new BloodDonationCertificateResponse(true, 0, 'Message sent successfully', imageContent);
        }).catch(err => {
            throw err;
        })
    }

    async saveBloodDonationBroadCastEntry(id: string, username: string, phone: string, constituency: string): Promise<number> {
        const ent = new BloodDonationUser();
        ent.refId = id;
        ent.username = username;
        ent.createdUser = 'SYSTEM';
        ent.contact = phone;
        ent.constituency = constituency;
        const savedRec = await this.bloodDonUser.save(ent);
        return savedRec.id;
    }

    /**
     * OLD IMPLEMENTATION - NOT USED ANYMORE
     * @param recipient 
     * @param greeting 
     * @param message 
     * @param sender 
     * @param personal 
     */
    async broadcastMessage(recipient: string, greeting: string, message: string, sender: string, personal: boolean) {
        var qs = require("querystring");
        var http = require("https");
        let msg = '';
        if (greeting) {
            msg += "*" + greeting + "*\n";
        }
        msg += message;
        if (sender) {
            // msg += "\n*From: "+sender+"*";
        }

        var options = {
            method: "POST",
            hostname: "api.ultramsg.com",
            port: null,
            path: "/instance18516/messages/chat",
            headers: {
                "content-type": "application/x-www-form-urlencoded"
            },
            timeout: 3000,
        };

        var req = await http.request(options, function (res, err) {
            var chunks: any[] = [];
            res.on("data", function (chunk) {
                chunks.push(chunk);
            });
            res.on("end", function () {
                var body = Buffer.concat(chunks);
            });
        });
        const prefix = personal ? "91" : "";
        const type = personal ? "@c.us" : "@g.us";
        // const to = prefix+recipient+type;
        console.log(recipient.toString());
        req.write(qs.stringify({
            token: appConfig.keys.whatsappLicence,
            to: recipient,//'919030069351@c.us',
            body: msg,
            priority: '1',
            referenceId: ''
        }));
        req.on('response', function (res) {
            // console.log(res.statusCode);
            // mainResponse.send(new MessageResponse(true, 'Message sent'));
        });
        req.on('error', function (res) {
            // console.log(res.statusCode);
            // mainResponse.send(new MessageResponse(false, 'Message could not be sent'));
        });
        req.end();
    }
}
